export let accTabListOverflowCountSingular = "w6dPgb";
export let accTabListOverflowCountFirstPlural = "r86zde";
export let accTabListOverflowCountSecondGenitivePlural = "aO69e";
export let accTabListOverflowTabTitle = "$d6idc";
export default {accTabListOverflowCountSingular,accTabListOverflowCountFirstPlural,accTabListOverflowCountSecondGenitivePlural,accTabListOverflowTabTitle};